<template>
  <div class="wrapper">
      <div id="logo-wrap">
          <img src="@/assets/img/logo.png" id="logo"/>
          <h4>KBL APP</h4>
      </div>
      <div id="login-form">
        <loader v-show="loader"/>
        <form @submit.prevent>
          <div class="row">
            <div class="col-md-12">
              <fg-input
                type="text"
                label="Email"
                placeholder="Enter a Email"
                v-model="email"
              >
              </fg-input>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12">
              <fg-input
                type="password"
                label="Password"
                placeholder="Enter a Password"
                v-model="password"
              >
              </fg-input>
            </div>
          </div>
          <div class="text-center">
            <p-button type="info" round @click.native.prevent="login">
              Login
            </p-button>
          </div>
          <div class="clearfix"></div>
        </form>
      </div>

    </div>
</template>
<style scoped>
#login-form{width:30%; margin:0 auto;  padding: 30px; border-radius: 10px 10px 10px 10px;
-webkit-border-radius: 10px 10px 10px 10px;
-moz-border-radius: 10px 10px 10px 10px;}
#logo-wrap{width:20%; margin:0 auto; margin-bottom: 10px; text-align:center;}
#logo{width:50%; margin-top:50px; margin-bottom: 20px;}
#logo input[type="text"], #logo input[type="password"]{ border: 1px solid;}
#logo label{font-weight: bold!important;}




</style>
<script>
import api  from "@/static/config.json";
import axios from 'axios'
import Loader from "@/components/Loader";

import { Capacitor } from '@capacitor/core';
import { PushNotifications } from '@capacitor/push-notifications';
import { FCM } from '@capacitor-community/fcm';

export default {

  components: {
    Loader
  },
  data(){
    return{
      email: '',
      password: '',
      type: ["", "info", "success", "warning", "danger"],
      notifications: {
        topCenter: false,
      },
      loader:false
    }
  },
  methods: {
      login(){

        this.loader = true;

        axios.post(api.API_URL+'/login', {
                    email: this.email,
                    password: this.password,
                    fcm: localStorage.getItem('fcm'),
                })
                    .then(({data}) => {
                        this.loader = false;
                        this.notifyVue('top', 'center','success','Login Successfully','ti-announcement')
                        localStorage.setItem("token", data.authorization.access_token);
                        localStorage.setItem("role_id", data.user.role_id);
                        localStorage.setItem("fullname", data.user.name);
                        localStorage.setItem("user_id", data.user.id);
                        this.$router.push({name: 'dashboard'})
                        
                    })
                    .catch((error) => {
                        this.loader = false;
                        try {
                          if(error.response.status==400){
                            this.notifyVue('top', 'center','danger',error.response.data.error.message,'ti-hand-stop')
                          }else if(error.response.status==422){
                            this.notifyVue('top', 'center','danger',error.response.data.message,'ti-hand-stop')
                          }
                        }
                        catch(err) {
                        
                        }
                    });
      },
      notifyVue(verticalAlign, horizontalAlign,type,msg,icon) {
      const color = Math.floor(Math.random() * 4 + 1);
      this.$notify({
        title:msg,
        icon: icon,
        horizontalAlign: horizontalAlign,
        verticalAlign: verticalAlign,
        type: type,
      });
    },
    subscribe () {
      const fcm = new FCM();
      const token =  fcm.getToken();
      console.log('token : ' + token);

      // FCM.subscribeTo({ topic: "sales" })
      //     .then(() => alert(`subscribed to topic`))
      //     .catch((err) => console.log(err));
    },
  },
  async mounted(){
    
    if(Capacitor.isNativePlatform()) {
        let permStatus = await PushNotifications.checkPermissions();

        if (permStatus.receive === 'prompt') {
          permStatus = await PushNotifications.requestPermissions();
        }

        if (permStatus.receive !== 'granted') {
          throw new Error('User denied permissions!');
        }

        await PushNotifications.register();

        await PushNotifications.getDeliveredNotifications();
        

        await PushNotifications.addListener('registration', token => {
          localStorage.setItem("fcm", token.value);
        });

        await PushNotifications.addListener('registrationError', err => {
          console.error('Registration error: ', err.error);
        });

        await PushNotifications.addListener('pushNotificationReceived', notification => {
          console.log('Push notification received: ', notification);
        });

        await PushNotifications.addListener('pushNotificationActionPerformed', notification => {
          console.log('Push notification action performed', notification.actionId, notification.inputValue);
        });
    }
    

      
    
  }
};
</script>


